import { Injectable, inject } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { signalServiceEndpoints } from 'src/app/helpers/urls';
import { AuthService } from '../api/auth-api';

@Injectable({
  providedIn: 'root'
})
export class SignalHubService {
  private authService = inject(AuthService);

  private readonly hubConnection: HubConnection;

  constructor() {
    const authService = this.authService;

    this.hubConnection = new HubConnectionBuilder()
      .withUrl(signalServiceEndpoints.hubEndpoint, {
        accessTokenFactory: () => authService.getToken()
        //withCredentials: false
      })
      .withAutomaticReconnect()
      .build();
  }

  getHubConnection(): HubConnection {
    return this.hubConnection;
  }

  async connect(): Promise<void> {
    await this.hubConnection.start();
    // eslint-disable-next-line no-console
    console.log('SignalR connected');
  }

  async register(): Promise<void> {
    try {
      await this.hubConnection.invoke('Register');
    } catch (error) {
      console.error('Error invoking Register():', error);
    }
  }
}
